import { useState } from 'react';
import { Box, Popover } from '@mui/material';
import classNames from 'classnames';

import { WSocketConnectionState } from '../utils/WSocket';
import { Button, ButtonGroup } from './Button';
import LabelInput from './LabelInput';

import { useQAWebTool } from '../hooks/useQAWebTool';

import styles from './QAWebToolButton.module.scss';

const SOCKET_STATE_TEXT_MAP: Record<WSocketConnectionState, string> = {
    idle: 'Live Preview',
    connected: 'Disconnect',
    connecting: 'Disconnect',
    error: 'Live Preview',
};

export interface QAWebToolButtonProps {
    className?: string;
    onConnect?: () => void;
    onDisconnect?: () => void;
}

export const QAWebToolButton = ({
    className,
    onConnect,
    onDisconnect,
}: QAWebToolButtonProps) => {
    const webTool = useQAWebTool();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleOnClick = () => {
        switch (webTool.socketState) {
            case 'idle':
                webTool.connect();
                onConnect?.();
                break;
            case 'connecting':
                webTool.disconnect();
                onDisconnect?.();
                break;
            case 'connected':
                webTool.disconnect();
                onDisconnect?.();
                break;
            case 'error':
                webTool.connect();
                onConnect?.();
                break;
        }
    };
    return (
        <div className={classNames(styles.container, className)}>
            <ButtonGroup
                color={
                    webTool.socketState === 'connected'
                        ? 'default'
                        : 'secondary'
                }
            >
                <Button
                    onClick={handleOnClick}
                    loading={webTool.socketState === 'connecting'}
                    disabled={false}
                >
                    {SOCKET_STATE_TEXT_MAP[webTool.socketState]}
                </Button>
                <Button
                    onClick={(e) => setAnchorEl(e.currentTarget.parentElement)}
                >
                    <span
                        className={classNames(styles.dropDownIcon, {
                            [styles.dropDownIconActive]: Boolean(anchorEl),
                        })}
                    >
                        ▴
                    </span>
                </Button>
            </ButtonGroup>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ padding: 1 }}>
                    <LabelInput
                        size="semiwide"
                        label="IP Address"
                        name="ipAddress"
                        value={webTool.ipAddress}
                        onChange={(e) =>
                            webTool.setIpAddress(e.currentTarget.value)
                        }
                    />
                    <a
                        href="https://tocaboca.atlassian.net/wiki/spaces/TBW/pages/3918659609/CMS+User+Guide+for+Portal#Live-Preview"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Live Preview Documentation
                    </a>
                </Box>
            </Popover>
        </div>
    );
};
